import React from 'react';

export interface StepperCompletedProps {
  /** Label content */
  children: React.ReactNode;
}

export const StepperCompleted: React.FC<StepperCompletedProps> = () => null;
StepperCompleted.displayName = '@bigcapital/core/StepperCompleted';
